import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, Inject, LOCALE_ID, NgModule } from '@angular/core';
import localeHu from '@angular/common/locales/hu';
import { AppComponent } from './app.component';
import { NavbarModule } from './modules/navbar/navbar.module';
import { AppRoutingModule } from './app-routing.module';
import { WhyBillcityComponent } from './views/why-billcity/why-billcity.component';
import { HttpClientModule } from '@angular/common/http';
import { FooterComponent } from './views/footer/footer.component';
import { CommonModule, DOCUMENT, registerLocaleData } from '@angular/common';
import { DataSourceService } from './service/data-source.service';
import { Observable } from 'rxjs';
import { deviceTypes } from './utils/device-types';
import { TimelineModule } from './modules/timeline/timeline.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { environment } from '../environments/environment';
import { NgcCookieConsentModule, NgcCookieConsentService } from 'ngx-cookieconsent';
import { Angulartics2GoogleAnalytics, Angulartics2Module } from 'angulartics2';

registerLocaleData(localeHu, 'hu');

function initializeAppFactory(dataSourceService: DataSourceService): () => Observable<any> {
  return () => dataSourceService.init();
}

@NgModule({
  declarations: [AppComponent, WhyBillcityComponent, FooterComponent],
  imports: [
    BrowserModule,
    CommonModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    NavbarModule,
    TimelineModule,
    NgcCookieConsentModule.forRoot(environment.cookieConfig),
    Angulartics2Module.forRoot({
      developerMode: environment.production === false,
      pageTracking: {
        autoTrackVirtualPages: true,
      },
    }),
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAppFactory,
      deps: [DataSourceService],
      multi: true,
    },
    {
      provide: LOCALE_ID,
      useValue: 'hu-HU',
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(
    @Inject(DOCUMENT) document: Document,
    /* preload */ ngcCookieContentService: NgcCookieConsentService,
    private angulartics2GoogleAnalytics: Angulartics2GoogleAnalytics
  ) {
    document.body.classList.add(deviceTypes());
    this.angulartics2GoogleAnalytics.startTracking();
  }
}
